import React from "react";
import { Box, Typography } from "@mui/material";
import { colors, fonts } from "../theme";

// Reusable, consistent heading block used at the top of every section.
const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = "center" }) => {
  const titleColor = light ? colors.white : colors.navy;
  const subColor = light ? "rgba(255,255,255,0.85)" : colors.textMuted;
  // Accessible blue on light; brighter blue on dark surfaces.
  const eyebrowColor = light ? colors.blue : colors.blueInk;

  return (
    <Box sx={{ textAlign: align, maxWidth: 820, mx: align === "center" ? "auto" : 0, mb: 5 }}>
      {eyebrow && (
        <Typography
          sx={{
            color: eyebrowColor,
            fontWeight: 700,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            fontSize: "0.8rem",
            mb: 1.5,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontFamily: fonts.heading,
          fontWeight: 700,
          color: titleColor,
          fontSize: { xs: "1.6rem", md: "2.1rem" },
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>
      {/* Signature blue→pink accent bar with a pink dot — co-primary brand mark */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          mt: 2,
          mb: subtitle ? 2.5 : 0,
          justifyContent: align === "center" ? "center" : "flex-start",
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 4,
            borderRadius: 2,
            background: colors.duoGradient,
          }}
        />
        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: colors.pink }} />
      </Box>
      {subtitle && (
        <Typography sx={{ color: subColor, fontSize: "1.02rem", lineHeight: 1.7 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeading;
